export enum ActionType {
  FetchDeploymentStatus = 'deployment/fetchDeploymentStatus',
  FetchApplicationStep = 'application/fetchApplicationStep',
  ValidateOfferCode = 'application/validateOfferCode',
  FetchPrepopulatedData = 'direct-mail/fetchPrepopulatedData',
  FetchPreFillExperianData = 'pre-fill/fetchPreFillExperianData',
}
